import { Route, Routes } from 'react-router-dom';
import ClinicList from './ClinicList';
import ClinicContainer from './detail/ClinicContainer';

const Clinics = ({ user }: { user: any }) => {
  return (
    <Routes>
      <Route path="/" element={<ClinicList user={user} />} />
      <Route path={`/:clinicID/*`} element={<ClinicContainer user={user} />} />
      <Route path="*" element={<span>no match</span>} />
    </Routes>
  );
};

export default Clinics;
